module.exports = __webpack_public_path__ + "static/img/荣誉_01@2x.de29dc7a.png";